<template>
  <action-button
    rounded
    elevation="0"
    border
    :color="color"
    :loading="loading"
    :width="width"
    :height="height"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <span :class="textClass" class="font-weight-medium">
      <v-icon v-if="icon" class="material-icons-outlined">
        {{ icon }}
      </v-icon>
      <slot></slot>
    </span>
  </action-button>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';

export default {
  name: 'RoundedActionButton',
  components: {
    ActionButton,
  },
  props: {
    icon: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'grey lighten-3',
    },
    textClass: {
      type: String,
      default: 'grey--text text--darken-2',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    height: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
